module.exports = __webpack_public_path__ + "img/Bodice-Back-Ka-Ld.d5dce937.png";